import { render } from "./ContactInfo.vue?vue&type=template&id=f2e481ba&scoped=true"
import script from "./ContactInfo.vue?vue&type=script&lang=js"
export * from "./ContactInfo.vue?vue&type=script&lang=js"

import "./ContactInfo.vue?vue&type=style&index=0&id=f2e481ba&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e481ba"]])

export default __exports__